import styled from "styled-components";

export default styled.div`
    .textField {
        align-items: center;
        cursor: pointer;
        margin-bottom: 20px;
        background-color: #eeeeee;
        border-radius: 5px;
        overflow: hidden;
        display: flex;

        input {
            border: none;
            height: 40px;
            font-size: 18px;
            padding-left: 15px;
            outline: none;
            display: flex;
            flex-grow: 1;
            background-color: #eeeeee;
            position: relative;
        }

        svg {
            margin: 0 10px;
            color: #777777;
        }

        :hover {
            background-color: #dddddd;
            input {
                background-color: #dddddd;
            }
        }

        &.highlighted {
            border: 2px solid ${(props) => props.theme.fieldHighlightBorder};
            background-color: ${(props) =>
                props.theme.fieldHighlightBackground};

            input {
                height: 36px;
                padding-left: 13px;
                background-color: ${(props) =>
                    props.theme.fieldHighlightBackground};
            }

            :hover {
                background-color: ${(props) =>
                    props.theme.fieldHighlightHoverBackground};
                input {
                    background-color: ${(props) =>
                        props.theme.fieldHighlightHoverBackground};
                }
            }
        }

        &.error {
            border: 2px solid lightcoral;
            input {
                height: 36px;
                padding-left: 13px;
            }
        }

        &.disabled {
            cursor: not-allowed;
            input {
                cursor: not-allowed;
            }
            :hover {
                background-color: #eeeeee;
                input {
                    background-color: #eeeeee;
                }
            }
        }
    }

    .errorText {
        color: red;
        font-size: 14px;
        margin-top: -15px;
        margin-bottom: 10px;
    }
`;
